import TP from '../TimePicker'
import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: TP,
  name: 'DDITimePicker'
})
